// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  align-items: center !important;
}

ion-list {
  padding-bottom: 0px;
}

@media screen and (max-width: 420px) {
  .list-md-lines-none .item {
    max-height: 40px;
  }
}

.available-games-list {
  list-style-type: none;
}

.title {
  padding: 0px;
  width: 100%;
  text-align: center !important;
}

ul {
  padding: 0px;
  overflow-y: auto;
  height: 90%;
}
@media screen and (max-width: 1020px) {
  ul {
    padding-bottom: 50px;
  }
}

li {
  margin-top: 4px;
}

@media screen and (max-width: 1020px) {
  .container {
    height: 60vh;
  }
}

ion-header {
  position: sticky;
  top: 0px;
}

ion-content {
  height: 75%;
}
@media screen and (max-width: 1020px) and (orientation: landscape) {
  ion-content {
    height: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-available-games/popover-available-games.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAGI;EADJ;IAEI,gBAAA;EACF;AACF;;AACA;EACI,qBAAA;AAEJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,6BAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;AACJ;AAAI;EAJJ;IAKQ,oBAAA;EAGN;AACF;;AAAA;EACI,eAAA;AAGJ;;AACI;EADJ;IAEQ,YAAA;EAGN;AACF;;AAAA;EACI,gBAAA;EACA,QAAA;AAGJ;;AAAA;EACI,WAAA;AAGJ;AAFI;EAFJ;IAGQ,WAAA;EAKN;AACF","sourcesContent":["ion-item{\r\n    align-items: center!important;\r\n}\r\n\r\nion-list{\r\n    padding-bottom: 0px;\r\n}\r\n\r\n.list-md-lines-none .item {\r\n    @media screen and (max-width:420px){\r\n    max-height: 40px;\r\n    }\r\n}\r\n.available-games-list {\r\n    list-style-type: none;\r\n}\r\n\r\n\r\n.title {\r\n    padding: 0px;\r\n    width: 100%;\r\n    text-align: center !important;\r\n}\r\n\r\nul {\r\n    padding: 0px;\r\n    overflow-y: auto;\r\n    height: 90%;\r\n    @media screen and (max-width:1020px){\r\n        padding-bottom: 50px;\r\n    }\r\n}\r\n\r\nli {\r\n    margin-top: 4px;\r\n}\r\n \r\n.container {\r\n    @media screen and (max-width: 1020px) {\r\n        height: 60vh;\r\n    } \r\n}\r\n\r\nion-header {\r\n    position: sticky;\r\n    top: 0px;\r\n}\r\n\r\nion-content {\r\n    height: 75%;\r\n    @media screen and (max-width: 1020px) and (orientation: landscape) {\r\n        height: 90%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
